import * as d3 from 'd3';
import { React } from 'react';

const Legend = ({ colorScale, modeToEmoji }) => {
  // Define the legend values to show at intervals across the domain
  const legendValues = d3.scaleLinear()
    .domain([450, 3500])  // Set domain (same as the color scale)
    .ticks(5);  // Define the number of steps in the legend

  const modes = ['Walk', 'Tram', 'Bus', 'Subway', 'U of M Medical Center'];

  return (
    <g className="legend" transform="translate(50, 50)">
        <text x={650} y={15}>Distance from Hospital via Transit (Min)⏱️</text>
      {legendValues.map((value, i) => (
        <g key={i} transform={`translate(${650}, ${i * 30 + 30})`}>
          <rect
            width={20}
            height={20}
            fill={colorScale(value)}
          />
          <text
            x={30}
            y={15}
            fontSize={12}
            fill="black"
          >
            {Math.floor(value/60)} min
          </text>
        </g>
      ))}
      {modes.map((mode, i) => {
        return <g key={i} transform={`translate(${750}, ${i * 30 + 30})`}>
          <text
            x={30}
            y={15}
            fontSize={12}
            fill="black"
          >
            {modeToEmoji[mode.toUpperCase()]} = {mode}
          </text>
        </g>
      })}
    </g>
  );
};

export default Legend;